/** Schlagzeilen für Module der Regelversion 7. media.ts reicht `press` herein, um Import-Zyklen zu vermeiden. */
let pressFn: ((o: string, t: string, tone: number) => void) | null = null;
export function setPress7(fn: (o: string, t: string, tone: number) => void) { pressFn = fn; }
export const press7 = (o: string, t: string, tone: number) => { pressFn?.(o, t, tone); };
